/**
 * WordPress dependencies
 */
import {
	store,
	getElement,
	getContext,
	withScope,
} from '@wordpress/interactivity';

const { state, actions } = store('gems-blocks/doctor-carousel', {
	state: {
		get noPrevSlide() {
			const ctx = getContext();
			if (ctx.continuous) {
				return false;
			}
			return ctx.currentSlide === 0;
		},
		get noNextSlide() {
			const ctx = getContext();
			if (ctx.continuous) {
				return false;
			}
			return ctx.currentSlide === ctx.totalSlides - 1;
		},
		get currentPos() {
			const ctx = getContext();
			return `translateX(-${ctx.currentSlide * 100}%)`;
		},
		get transitionsSpeed() {
			const ctx = getContext();
			return Number(ctx.speed) * 1000;
		},
		get isActiveSlide() {
			const ctx = getContext();
			const { ref } = getElement();
			return ctx.currentSlide === ctx.slides.indexOf(ref);
		},
	},
	actions: {
		focusSlide: () => {
			const ctx = getContext();
			const { ref } = getElement();
			// Get the index of the clicked slide
			ctx.currentSlide = ctx.slides.indexOf(ref);
		},
		prevImage: () => {
			const ctx = getContext();
			if (ctx.continuous && ctx.currentSlide === 0) {
				ctx.currentSlide = ctx.totalSlides - 1;
				return;
			}
			ctx.currentSlide--;
		},
		nextImage: () => {
			const ctx = getContext();
			if (
				(ctx.continuous || ctx.autoplay) &&
				ctx.currentSlide === ctx.totalSlides - 1
			) {
				ctx.currentSlide = 0;
				return;
			}
			ctx.currentSlide++;
		},
		onTouchStart: (e) => {
			const ctx = getContext();
			ctx.swipe = e.changedTouches[0].clientX;
		},
		onTouchEnd: (e) => {
			const ctx = getContext();
			if (e.changedTouches[0].clientX < ctx.swipe) {
				if (!state.noNextSlide) {
					actions.nextImage();
				}
			} else {
				if (!state.noPrevSlide) {
					actions.prevImage();
				}
			}
			ctx.swipe = null;
		},
	},
	callbacks: {
		initSlideShow: () => {
			const ctx = getContext();
			if (ctx.autoplay) {
				setInterval(
					withScope(() => {
						actions.nextImage();
					}),
					state.transitionsSpeed
				);
			}
		},
		initSlide: () => {
			const ctx = getContext();
			const { ref } = getElement();
			ctx.slides.push(ref);
			ctx.totalSlides = ctx.slides.length;

			return () => {
				ctx.slides = ctx.slides.filter((s) => s !== ref);
			};
		},
	},
});

/**
 * Helper to log the data in a readable format. Useful for debugging parts of the store.
 *
 * Use console.log for non-store values.
 *
 * @param {*} data
 * @returns
 */
const debugLog = (data) => console.log(JSON.parse(JSON.stringify(data)));
